var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWnNussZm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1466 18.7638C21.6713 16.9294 22.5882 14.5718 22.5882 12C22.5882 6.15226 17.8477 1.41174 12 1.41174C6.15226 1.41174 1.41174 6.15226 1.41174 12C1.41174 17.8477 6.15226 22.5882 12 22.5882C13.52 22.5882 14.9653 22.2679 16.2719 21.6911",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9466 18.476C15.5527 18.476 18.476 15.5527 18.476 11.9466C18.476 8.34049 15.5527 5.41718 11.9466 5.41718C8.34049 5.41718 5.41718 8.34049 5.41718 11.9466C5.41718 15.5527 8.34049 18.476 11.9466 18.476Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.993 14.1107C13.1626 14.1107 14.1107 13.1626 14.1107 11.993C14.1107 10.8235 13.1626 9.87537 11.993 9.87537C10.8235 9.87537 9.87537 10.8235 9.87537 11.993C9.87537 13.1626 10.8235 14.1107 11.993 14.1107Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3031 20.1999L18.3097 20.1999",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWnNussZm);
export default __webpack_public_path__ + "static/media/WNNussZM.eae2cae866865c1edcf244ca688df6e0.svg";
export { ForwardRef as ReactComponent };